import { Trash2 } from "lucide-react";
import type { ConversationSummary } from "../chatClient";

function formatHistoryTime(ts: number): string {
  if (!ts) return "";
  const d = new Date(ts);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const time = d.toLocaleTimeString("zh-CN", { hour: "2-digit", minute: "2-digit" });
  if (sameDay) return time;
  return `${d.getMonth() + 1}/${d.getDate()} ${time}`;
}

export function HistoryModal({
  conversations,
  activeConversationId,
  onClose,
  onSelect,
  onDelete,
  onDeleteAll,
}: {
  conversations: ConversationSummary[];
  activeConversationId: string | null;
  onClose: () => void;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
  onDeleteAll: () => void;
}) {
  return (
    <div className="history-modal-overlay" onClick={onClose}>
      <div className="history-modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="history-modal-header">
          <h2 className="history-modal-title">历史对话</h2>
          <button className="btn btn-text history-modal-close" type="button" onClick={onClose}>
            关闭
          </button>
        </div>

        {conversations.length > 0 && (
          <button className="btn btn-text history-modal-delete-all" type="button" onClick={onDeleteAll}>
            <Trash2 size={14} className="icon" />
            <span>清空全部历史对话</span>
          </button>
        )}

        <ul className="history-list history-modal-list">
          {conversations.map((c) => (
            <li key={c.id} className="history-row">
              <button
                className={`history-item ${c.id === activeConversationId ? "active" : ""}`}
                type="button"
                onClick={() => onSelect(c.id)}
              >
                <span className="history-item-title">{c.title || "（未命名对话）"}</span>
                <span className="history-item-time">{formatHistoryTime(c.updated_at)}</span>
              </button>
              <button
                className="history-item-delete"
                type="button"
                title="删除该对话"
                onClick={() => onDelete(c.id)}
              >
                <Trash2 size={14} />
              </button>
            </li>
          ))}
          {conversations.length === 0 && <li className="history-empty">暂无历史对话</li>}
        </ul>
      </div>
    </div>
  );
}
